// @flowgenix/shared-ui/utils/registerServiceWorker
//
// Phase 2 / Step G — PWA / service-worker registration helper.
//
// Each app calls this once from src/index.js. We deliberately wait for
// `window.load` so SW registration never delays first paint, and we
// expose a no-op shape in non-browser environments (SSR / tests) so
// importers don't have to guard.
//
// The SW file path is the only per-app difference. Pass it explicitly
// so we don't have to special-case PUBLIC_URL / Capacitor base paths.

export function registerServiceWorker(swPath = '/service-worker.js') {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  const onLoad = () => {
    navigator.serviceWorker
      .register(swPath, { scope: dirOf(swPath) })
      .then((reg) => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.log('[SW] registered:', reg.scope);
        }
        // When a new SW takes over, refresh once so the user gets the
        // new shell. Avoids "stuck old version" complaints after a
        // release without forcing a noisy "update available" toast.
        let didReload = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (didReload) return;
          didReload = true;
          window.location.reload();
        });
      })
      .catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('[SW] registration failed:', err);
        }
      });
  };

  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }
}

export function unregisterServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
}

function dirOf(path) {
  const idx = path.lastIndexOf('/');
  if (idx <= 0) return '/';
  return path.slice(0, idx + 1);
}
